// i18n translations for EN / EL / SR
export const languages = [
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "el", label: "Ελληνικά", flag: "🇬🇷" },
  { code: "sr", label: "Srpski", flag: "🇷🇸" },
];

export const translations = {
  en: {
    nav: { search: "Search Players", about: "About", pricing: "Subscription", contact: "Contact", login: "Log In", signup: "Sign Up Free", dashboard: "Dashboard", logout: "Log Out" },
    hero: {
      badge: "The Football Scouting Operating System",
      title1: "Create your profile.",
      title2: "Add your videos.",
      title3: "Get discovered.",
      subtitle: "The professional scouting platform connecting young football talent with verified scouts, clubs, and colleges worldwide.",
      cta1: "Create Free Profile",
      cta2: "Search Players",
    },
    stats: { players: "Player Profiles", academies: "Academies", scouts: "Verified Scouts" },
    join: {
      title: "Join ScoutOS",
      subtitle: "Choose your role and get started in minutes",
      player: { title: "I'm a Player / Parent", desc: "Create a free football profile with videos, stats, and measurements. Get discovered by scouts worldwide.", cta: "Get Started" },
      academy: { title: "I'm an Academy", desc: "Manage your players' profiles, track scout interest, and showcase your academy to the scouting world.", cta: "Get Started" },
      scout: { title: "I'm a Scout / Club / Agent", desc: "Search verified player profiles, watch highlights, create watchlists, and connect with talent.", cta: "Get Started" },
    },
    how: {
      title: "How It Works",
      s1t: "Create Profile", s1d: "Add your details, position, measurements, and team history.",
      s2t: "Add Videos", s2d: "Paste YouTube links for highlights, full matches, and training clips.",
      s3t: "Get Discovered", s3d: "Verified scouts search and find players matching their criteria.",
      s4t: "Connect", s4d: "Scouts request contact through the platform — safe and organized.",
    },
    featured: { title: "Featured Players", viewAll: "View All" },
    finalCta: { title: "Ready to get discovered?", subtitle: "Join thousands of young football players showcasing their talent to verified scouts worldwide.", cta: "Create Your Free Profile" },
    search: {
      title: "Search Players", subtitle: "Find the next generation of football talent",
      searchPlaceholder: "Search by name or club...",
      position: "Position", country: "Country", foot: "Preferred Foot", all: "All",
      openTrial: "Open for trial only", results: "players found", clear: "Clear filters", noResults: "No players match your filters.",
    },
    player: {
      years: "years", views: "views", openTrial: "Open for Trial",
      overview: "Overview", videos: "Videos", stats: "Statistics",
      height: "Height", foot: "Preferred foot", position: "Position", club: "Club", location: "Location", age: "Age",
      appearances: "Appearances", goals: "Goals", assists: "Assists", minutes: "Minutes", cleanSheets: "Clean Sheets",
      addWatch: "Add to Watchlist", removeWatch: "Remove from Watchlist", contact: "Request Contact", back: "Back to search",
      contactSent: "Contact request sent! The player's academy will be notified.",
    },
    about: {
      title: "About ScoutOS",
      lead: "The professional digital scouting ecosystem connecting football players and academies with scouts, clubs, and collegiate recruiters worldwide.",
      mTitle: "Our Mission", mText: "Every year, thousands of talented young players go unnoticed simply because they lack access to the right scouting networks. ScoutOS levels the playing field — giving every player a professional profile and every scout a powerful discovery tool.",
      vTitle: "Our Vision", vText: "A world where talent is discovered on merit, not on connections. We are building the operating system for global football scouting.",
      f1t: "For Players", f1d: "A free, professional profile with videos, stats, and measurements — visible to scouts worldwide.",
      f2t: "For Academies", f2d: "Showcase your talent, track scout interest, and manage all your players in one dashboard.",
      f3t: "For Scouts", f3d: "Advanced search, verified profiles, watchlists and private notes to find your next signing.",
    },
    pricing: {
      title: "Scout Subscription Plans",
      subtitle: "Player profiles are always free. Scouts, clubs, agents, and colleges choose the plan that fits their needs.",
      month: "/month", getStarted: "Get Started", subscribe: "Subscribe", mostPopular: "Most Popular", premium: "Premium", current: "Current Plan",
      freeTitle: "Free for Players & Parents",
      freeText: "Create your football profile, add videos, and get discovered — completely free. Premium features for players coming soon.",
      freeCta: "Create Free Player Profile",
      loginRequired: "Please log in to subscribe.",
    },
    auth: {
      loginTitle: "Welcome back", loginSubtitle: "Log in to your ScoutOS account",
      signupTitle: "Create your account", signupSubtitle: "Join the football scouting ecosystem",
      name: "Full name", email: "Email", password: "Password", role: "I am a...",
      rolePlayer: "Player / Parent", roleAcademy: "Academy", roleScout: "Scout / Club / Agent",
      loginBtn: "Log In", signupBtn: "Create Account",
      noAccount: "Don't have an account?", haveAccount: "Already have an account?",
      signupLink: "Sign up", loginLink: "Log in",
      loginSuccess: "Logged in successfully!", signupSuccess: "Account created! Welcome to ScoutOS.",
      invalid: "Invalid email or password.",
    },
    dashboard: {
      title: "Dashboard", welcome: "Welcome back",
      subscription: "Subscription", noSub: "No active subscription", active: "Active",
      manage: "Manage Plans", watchlist: "My Watchlist", watchlistEmpty: "Your watchlist is empty. Start searching for players.",
      views: "Profile Views", role: "Role", browse: "Browse Players",
    },
    footer: { tagline: "The Football Scouting Operating System", product: "Product", company: "Company", legal: "Legal", rights: "All rights reserved." },
    payment: { processing: "Processing payment...", success: "Payment successful! Your subscription is now active.", failed: "Payment failed or was cancelled.", checking: "Checking payment status...", timeout: "Payment status check timed out. Please check your dashboard." },
    contact: {
      title: "Get in touch", subtitle: "Questions, partnerships or support — we'd love to hear from you.",
      name: "Full name", email: "Email", subject: "Subject", message: "Message",
      namePh: "John Doe", emailPh: "you@email.com", subjectPh: "How can we help?", messagePh: "Write your message...",
      send: "Send Message", sending: "Sending...",
      success: "Message sent! We'll get back to you soon.", error: "Something went wrong. Please try again.",
      infoTitle: "Contact info", emailLabel: "Email us", responseTime: "We usually reply within 24 hours.",
    },
    roles: { player: "Player / Parent", academy_agent: "Pro Academy / Agent", pro_team: "Professional Team" },
    onboard: {
      title: "Welcome to ScoutOS", subtitle: "Tell us who you are to get started",
      playerDesc: "Create a free scouting profile with videos and stats. Get discovered.",
      academyDesc: "Search and scout verified player profiles. 7-day free trial.",
      proDesc: "Full scouting suite for professional clubs. 7-day free trial.",
      continue: "Continue", free: "Free forever", trial: "7-day free trial",
    },
    sub: {
      monthly: "Monthly", annual: "Annual", save: "Save 2 months", trialBadge: "7-day free trial",
      startTrial: "Start Free Trial", trialing: "Trial", active: "Active", canceled: "Canceled",
      trialEnds: "Trial ends", renews: "Renews", perMonth: "/mo", perYear: "/yr",
      needSub: "You need an active subscription or trial to view players.", viewPlans: "View Plans",
      checking: "Confirming your subscription...", started: "Your free trial has started!",
    },
    myprofile: {
      title: "My Player Profile", subtitle: "Complete your profile and add your best videos",
      name: "Full name", position: "Position", city: "City", country: "Country", height: "Height (cm)",
      foot: "Preferred foot", birthYear: "Birth year", club: "Club / Team", bio: "Bio", openTrial: "Open for trial",
      videos: "Videos", videoTitle: "Video title", videoUrl: "Video link", addVideo: "Add video", save: "Save Profile",
      saved: "Profile saved!", guide: "Video Guide", guideHint: "Not sure how to record? Read the guide",
      noVideos: "No videos yet. Add your first video link above.",
      consent: "I confirm that, for players under 18, I have the consent of a parent or legal guardian to create and publish this profile.",
      consentRequired: "Parental/guardian consent is required to register a minor.",
    },
  },
  el: {
    nav: { search: "Αναζήτηση Παικτών", about: "Σχετικά", pricing: "Συνδρομή", contact: "Επικοινωνία", login: "Σύνδεση", signup: "Δωρεάν Εγγραφή", dashboard: "Πίνακας", logout: "Αποσύνδεση" },
    hero: {
      badge: "Το Λειτουργικό Σύστημα Scouting Ποδοσφαίρου",
      title1: "Φτιάξε το προφίλ σου.",
      title2: "Πρόσθεσε τα βίντεό σου.",
      title3: "Γίνε γνωστός.",
      subtitle: "Η επαγγελματική πλατφόρμα scouting που συνδέει νεαρά ποδοσφαιρικά ταλέντα με πιστοποιημένους scouts, συλλόγους και κολέγια παγκοσμίως.",
      cta1: "Δωρεάν Προφίλ",
      cta2: "Αναζήτηση Παικτών",
    },
    stats: { players: "Προφίλ Παικτών", academies: "Ακαδημίες", scouts: "Πιστοποιημένοι Scouts" },
    join: {
      title: "Γίνε μέλος του ScoutOS",
      subtitle: "Διάλεξε τον ρόλο σου και ξεκίνα σε λίγα λεπτά",
      player: { title: "Είμαι Παίκτης / Γονέας", desc: "Δημιούργησε δωρεάν προφίλ με βίντεο, στατιστικά και σωματομετρικά. Γίνε γνωστός σε scouts παγκοσμίως.", cta: "Ξεκίνα" },
      academy: { title: "Είμαι Ακαδημία", desc: "Διαχειρίσου τα προφίλ των παικτών σου, παρακολούθησε το ενδιαφέρον scouts και πρόβαλε την ακαδημία σου.", cta: "Ξεκίνα" },
      scout: { title: "Είμαι Scout / Σύλλογος / Ατζέντης", desc: "Αναζήτησε πιστοποιημένα προφίλ, δες highlights, φτιάξε λίστες και έλα σε επαφή με ταλέντα.", cta: "Ξεκίνα" },
    },
    how: {
      title: "Πώς Λειτουργεί",
      s1t: "Δημιούργησε Προφίλ", s1d: "Πρόσθεσε στοιχεία, θέση, σωματομετρικά και ιστορικό ομάδων.",
      s2t: "Πρόσθεσε Βίντεο", s2d: "Επικόλλησε συνδέσμους YouTube για highlights, αγώνες και προπονήσεις.",
      s3t: "Γίνε Γνωστός", s3d: "Πιστοποιημένοι scouts αναζητούν και βρίσκουν παίκτες με τα κριτήριά τους.",
      s4t: "Σύνδεση", s4d: "Οι scouts ζητούν επαφή μέσω της πλατφόρμας — ασφαλώς και οργανωμένα.",
    },
    featured: { title: "Προτεινόμενοι Παίκτες", viewAll: "Δες Όλους" },
    finalCta: { title: "Έτοιμος να γίνεις γνωστός;", subtitle: "Γίνε μέλος χιλιάδων νεαρών παικτών που προβάλλουν το ταλέντο τους σε πιστοποιημένους scouts.", cta: "Δημιούργησε Δωρεάν Προφίλ" },
    search: {
      title: "Αναζήτηση Παικτών", subtitle: "Βρες την επόμενη γενιά ποδοσφαιρικού ταλέντου",
      searchPlaceholder: "Αναζήτηση με όνομα ή σύλλογο...",
      position: "Θέση", country: "Χώρα", foot: "Πόδι", all: "Όλα",
      openTrial: "Μόνο διαθέσιμοι για δοκιμή", results: "παίκτες βρέθηκαν", clear: "Καθαρισμός φίλτρων", noResults: "Κανένας παίκτης δεν ταιριάζει στα φίλτρα.",
    },
    player: {
      years: "ετών", views: "προβολές", openTrial: "Διαθέσιμος για Δοκιμή",
      overview: "Επισκόπηση", videos: "Βίντεο", stats: "Στατιστικά",
      height: "Ύψος", foot: "Πόδι", position: "Θέση", club: "Σύλλογος", location: "Τοποθεσία", age: "Ηλικία",
      appearances: "Συμμετοχές", goals: "Γκολ", assists: "Ασίστ", minutes: "Λεπτά", cleanSheets: "Μηδέν Παθητικό",
      addWatch: "Προσθήκη στη Λίστα", removeWatch: "Αφαίρεση από τη Λίστα", contact: "Αίτημα Επαφής", back: "Πίσω στην αναζήτηση",
      contactSent: "Το αίτημα επαφής στάλθηκε! Η ακαδημία του παίκτη θα ειδοποιηθεί.",
    },
    about: {
      title: "Σχετικά με το ScoutOS",
      lead: "Το επαγγελματικό ψηφιακό οικοσύστημα scouting που συνδέει παίκτες και ακαδημίες με scouts, συλλόγους και κολέγια παγκοσμίως.",
      mTitle: "Η Αποστολή μας", mText: "Κάθε χρόνο χιλιάδες ταλαντούχοι νεαροί παίκτες μένουν απαρατήρητοι επειδή δεν έχουν πρόσβαση στα σωστά δίκτυα scouting. Το ScoutOS εξισώνει τους όρους — δίνοντας σε κάθε παίκτη επαγγελματικό προφίλ και σε κάθε scout ένα ισχυρό εργαλείο ανακάλυψης.",
      vTitle: "Το Όραμά μας", vText: "Ένας κόσμος όπου το ταλέντο ανακαλύπτεται με βάση την αξία, όχι τις γνωριμίες. Χτίζουμε το λειτουργικό σύστημα του παγκόσμιου scouting.",
      f1t: "Για Παίκτες", f1d: "Δωρεάν επαγγελματικό προφίλ με βίντεο, στατιστικά και σωματομετρικά — ορατό σε scouts παγκοσμίως.",
      f2t: "Για Ακαδημίες", f2d: "Πρόβαλε το ταλέντο σου, παρακολούθησε ενδιαφέρον scouts και διαχειρίσου όλους τους παίκτες σε έναν πίνακα.",
      f3t: "Για Scouts", f3d: "Προηγμένη αναζήτηση, πιστοποιημένα προφίλ, λίστες και ιδιωτικές σημειώσεις για να βρεις τη επόμενη μεταγραφή.",
    },
    pricing: {
      title: "Πλάνα Συνδρομής Scout",
      subtitle: "Τα προφίλ παικτών είναι πάντα δωρεάν. Scouts, σύλλογοι, ατζέντηδες και κολέγια επιλέγουν το πλάνο που τους ταιριάζει.",
      month: "/μήνα", getStarted: "Ξεκίνα", subscribe: "Εγγραφή", mostPopular: "Πιο Δημοφιλές", premium: "Premium", current: "Τρέχον Πλάνο",
      freeTitle: "Δωρεάν για Παίκτες & Γονείς",
      freeText: "Δημιούργησε προφίλ, πρόσθεσε βίντεο και γίνε γνωστός — εντελώς δωρεάν. Premium λειτουργίες για παίκτες έρχονται σύντομα.",
      freeCta: "Δωρεάν Προφίλ Παίκτη",
      loginRequired: "Παρακαλώ συνδέσου για να κάνεις εγγραφή.",
    },
    auth: {
      loginTitle: "Καλώς ήρθες πίσω", loginSubtitle: "Συνδέσου στον λογαριασμό σου ScoutOS",
      signupTitle: "Δημιούργησε λογαριασμό", signupSubtitle: "Γίνε μέλος του οικοσυστήματος scouting",
      name: "Ονοματεπώνυμο", email: "Email", password: "Κωδικός", role: "Είμαι...",
      rolePlayer: "Παίκτης / Γονέας", roleAcademy: "Ακαδημία", roleScout: "Scout / Σύλλογος / Ατζέντης",
      loginBtn: "Σύνδεση", signupBtn: "Δημιουργία Λογαριασμού",
      noAccount: "Δεν έχεις λογαριασμό;", haveAccount: "Έχεις ήδη λογαριασμό;",
      signupLink: "Εγγραφή", loginLink: "Σύνδεση",
      loginSuccess: "Συνδέθηκες επιτυχώς!", signupSuccess: "Ο λογαριασμός δημιουργήθηκε! Καλώς ήρθες στο ScoutOS.",
      invalid: "Λάθος email ή κωδικός.",
    },
    dashboard: {
      title: "Πίνακας Ελέγχου", welcome: "Καλώς ήρθες",
      subscription: "Συνδρομή", noSub: "Καμία ενεργή συνδρομή", active: "Ενεργή",
      manage: "Διαχείριση Πλάνων", watchlist: "Η Λίστα μου", watchlistEmpty: "Η λίστα σου είναι άδεια. Ξεκίνα να ψάχνεις παίκτες.",
      views: "Προβολές Προφίλ", role: "Ρόλος", browse: "Δες Παίκτες",
    },
    footer: { tagline: "Το Λειτουργικό Σύστημα Scouting Ποδοσφαίρου", product: "Προϊόν", company: "Εταιρεία", legal: "Νομικά", rights: "Με επιφύλαξη παντός δικαιώματος." },
    payment: { processing: "Επεξεργασία πληρωμής...", success: "Επιτυχής πληρωμή! Η συνδρομή σου είναι πλέον ενεργή.", failed: "Η πληρωμή απέτυχε ή ακυρώθηκε.", checking: "Έλεγχος κατάστασης πληρωμής...", timeout: "Ο έλεγχος πληρωμής έληξε. Έλεγξε τον πίνακά σου." },
    contact: {
      title: "Επικοινώνησε μαζί μας", subtitle: "Ερωτήσεις, συνεργασίες ή υποστήριξη — θα χαρούμε να σε ακούσουμε.",
      name: "Ονοματεπώνυμο", email: "Email", subject: "Θέμα", message: "Μήνυμα",
      namePh: "Γιάννης Παπαδόπουλος", emailPh: "you@email.com", subjectPh: "Πώς μπορούμε να βοηθήσουμε;", messagePh: "Γράψε το μήνυμά σου...",
      send: "Αποστολή Μηνύματος", sending: "Αποστολή...",
      success: "Το μήνυμα στάλθηκε! Θα επικοινωνήσουμε σύντομα.", error: "Κάτι πήγε στραβά. Δοκίμασε ξανά.",
      infoTitle: "Στοιχεία επικοινωνίας", emailLabel: "Στείλε μας email", responseTime: "Απαντάμε συνήθως εντός 24 ωρών.",
    },
    roles: { player: "Παίκτης / Γονέας", academy_agent: "Pro Ακαδημία / Ατζέντης", pro_team: "Επαγγελματική Ομάδα" },
    onboard: {
      title: "Καλώς ήρθες στο ScoutOS", subtitle: "Πες μας ποιος είσαι για να ξεκινήσεις",
      playerDesc: "Δημιούργησε δωρεάν προφίλ με βίντεο και στατιστικά. Γίνε γνωστός.",
      academyDesc: "Ψάξε και αξιολόγησε πιστοποιημένα προφίλ παικτών. 7 ημέρες δωρεάν.",
      proDesc: "Πλήρες scouting suite για επαγγελματικούς συλλόγους. 7 ημέρες δωρεάν.",
      continue: "Συνέχεια", free: "Πάντα δωρεάν", trial: "7 ημέρες δωρεάν δοκιμή",
    },
    sub: {
      monthly: "Μηνιαία", annual: "Ετήσια", save: "2 μήνες δώρο", trialBadge: "7 ημέρες δωρεάν",
      startTrial: "Ξεκίνα Δωρεάν Δοκιμή", trialing: "Δοκιμή", active: "Ενεργή", canceled: "Ακυρωμένη",
      trialEnds: "Λήξη δοκιμής", renews: "Ανανέωση", perMonth: "/μήνα", perYear: "/έτος",
      needSub: "Χρειάζεσαι ενεργή συνδρομή ή δοκιμή για να δεις παίκτες.", viewPlans: "Δες τα Πλάνα",
      checking: "Επιβεβαίωση συνδρομής...", started: "Η δωρεάν δοκιμή σου ξεκίνησε!",
    },
    myprofile: {
      title: "Το Προφίλ μου", subtitle: "Συμπλήρωσε το προφίλ σου και πρόσθεσε τα καλύτερα βίντεο",
      name: "Ονοματεπώνυμο", position: "Θέση", city: "Πόλη", country: "Χώρα", height: "Ύψος (cm)",
      foot: "Πόδι", birthYear: "Έτος γέννησης", club: "Σύλλογος / Ομάδα", bio: "Βιογραφικό", openTrial: "Διαθέσιμος για δοκιμή",
      videos: "Βίντεο", videoTitle: "Τίτλος βίντεο", videoUrl: "Σύνδεσμος βίντεο", addVideo: "Προσθήκη βίντεο", save: "Αποθήκευση",
      saved: "Το προφίλ αποθηκεύτηκε!", guide: "Οδηγός Βίντεο", guideHint: "Δεν ξέρεις πώς να γράψεις; Δες τον οδηγό",
      noVideos: "Δεν υπάρχουν βίντεο ακόμα. Πρόσθεσε τον πρώτο σύνδεσμο πιο πάνω.",
      consent: "Επιβεβαιώνω ότι, για παίκτες κάτω των 18 ετών, έχω τη συναίνεση γονέα ή νόμιμου κηδεμόνα για τη δημιουργία και δημοσίευση αυτού του προφίλ.",
      consentRequired: "Απαιτείται γονική/κηδεμονική συναίνεση για την εγγραφή ανηλίκου.",
    },
  },
  sr: {
    nav: { search: "Pretraga Igrača", about: "O nama", pricing: "Pretplata", contact: "Kontakt", login: "Prijava", signup: "Besplatna Registracija", dashboard: "Kontrolna tabla", logout: "Odjava" },
    hero: {
      badge: "Operativni Sistem za Fudbalski Skauting",
      title1: "Napravi svoj profil.",
      title2: "Dodaj svoje snimke.",
      title3: "Budi otkriven.",
      subtitle: "Profesionalna skauting platforma koja povezuje mlade fudbalske talente sa verifikovanim skautima, klubovima i koledžima širom sveta.",
      cta1: "Besplatan Profil",
      cta2: "Pretraga Igrača",
    },
    stats: { players: "Profili Igrača", academies: "Akademije", scouts: "Verifikovani Skauti" },
    join: {
      title: "Pridruži se ScoutOS-u",
      subtitle: "Izaberi svoju ulogu i počni za nekoliko minuta",
      player: { title: "Ja sam Igrač / Roditelj", desc: "Napravi besplatan fudbalski profil sa snimcima, statistikom i merama. Budi otkriven od skauta širom sveta.", cta: "Počni" },
      academy: { title: "Ja sam Akademija", desc: "Upravljaj profilima svojih igrača, prati interesovanje skauta i predstavi svoju akademiju.", cta: "Počni" },
      scout: { title: "Ja sam Skaut / Klub / Agent", desc: "Pretraži verifikovane profile, gledaj snimke, pravi liste i poveži se sa talentima.", cta: "Počni" },
    },
    how: {
      title: "Kako Funkcioniše",
      s1t: "Napravi Profil", s1d: "Dodaj detalje, poziciju, mere i istoriju timova.",
      s2t: "Dodaj Snimke", s2d: "Nalepi YouTube linkove za snimke, mečeve i treninge.",
      s3t: "Budi Otkriven", s3d: "Verifikovani skauti traže i nalaze igrače po svojim kriterijumima.",
      s4t: "Poveži se", s4d: "Skauti traže kontakt kroz platformu — bezbedno i organizovano.",
    },
    featured: { title: "Istaknuti Igrači", viewAll: "Vidi Sve" },
    finalCta: { title: "Spreman da budeš otkriven?", subtitle: "Pridruži se hiljadama mladih fudbalera koji predstavljaju svoj talenat verifikovanim skautima.", cta: "Napravi Besplatan Profil" },
    search: {
      title: "Pretraga Igrača", subtitle: "Pronađi sledeću generaciju fudbalskog talenta",
      searchPlaceholder: "Pretraži po imenu ili klubu...",
      position: "Pozicija", country: "Država", foot: "Noga", all: "Sve",
      openTrial: "Samo dostupni za probu", results: "igrača pronađeno", clear: "Očisti filtere", noResults: "Nijedan igrač ne odgovara filterima.",
    },
    player: {
      years: "godina", views: "pregleda", openTrial: "Dostupan za Probu",
      overview: "Pregled", videos: "Snimci", stats: "Statistika",
      height: "Visina", foot: "Noga", position: "Pozicija", club: "Klub", location: "Lokacija", age: "Godine",
      appearances: "Nastupi", goals: "Golovi", assists: "Asistencije", minutes: "Minuti", cleanSheets: "Čiste Mreže",
      addWatch: "Dodaj u Listu", removeWatch: "Ukloni iz Liste", contact: "Zatraži Kontakt", back: "Nazad na pretragu",
      contactSent: "Zahtev za kontakt poslat! Akademija igrača će biti obaveštena.",
    },
    about: {
      title: "O ScoutOS-u",
      lead: "Profesionalni digitalni skauting ekosistem koji povezuje igrače i akademije sa skautima, klubovima i koledž regruterima širom sveta.",
      mTitle: "Naša Misija", mText: "Svake godine hiljade talentovanih mladih igrača ostaju neprimećeni jer nemaju pristup pravim skauting mrežama. ScoutOS izjednačava šanse — dajući svakom igraču profesionalni profil, a svakom skautu moćan alat za otkrivanje.",
      vTitle: "Naša Vizija", vText: "Svet u kome se talenat otkriva po zaslugama, ne po vezama. Gradimo operativni sistem za globalni fudbalski skauting.",
      f1t: "Za Igrače", f1d: "Besplatan profesionalni profil sa snimcima, statistikom i merama — vidljiv skautima širom sveta.",
      f2t: "Za Akademije", f2d: "Predstavi svoj talenat, prati interesovanje skauta i upravljaj svim igračima na jednom mestu.",
      f3t: "Za Skaute", f3d: "Napredna pretraga, verifikovani profili, liste i privatne beleške za pronalazak sledećeg pojačanja.",
    },
    pricing: {
      title: "Skaut Planovi Pretplate",
      subtitle: "Profili igrača su uvek besplatni. Skauti, klubovi, agenti i koledži biraju plan koji im odgovara.",
      month: "/mesec", getStarted: "Počni", subscribe: "Pretplati se", mostPopular: "Najpopularniji", premium: "Premium", current: "Trenutni Plan",
      freeTitle: "Besplatno za Igrače i Roditelje",
      freeText: "Napravi fudbalski profil, dodaj snimke i budi otkriven — potpuno besplatno. Premium funkcije za igrače uskoro.",
      freeCta: "Napravi Besplatan Profil",
      loginRequired: "Molimo prijavite se da biste se pretplatili.",
    },
    auth: {
      loginTitle: "Dobrodošli nazad", loginSubtitle: "Prijavite se na svoj ScoutOS nalog",
      signupTitle: "Napravite nalog", signupSubtitle: "Pridružite se skauting ekosistemu",
      name: "Puno ime", email: "Email", password: "Lozinka", role: "Ja sam...",
      rolePlayer: "Igrač / Roditelj", roleAcademy: "Akademija", roleScout: "Skaut / Klub / Agent",
      loginBtn: "Prijava", signupBtn: "Napravi Nalog",
      noAccount: "Nemate nalog?", haveAccount: "Već imate nalog?",
      signupLink: "Registrujte se", loginLink: "Prijavite se",
      loginSuccess: "Uspešno ste se prijavili!", signupSuccess: "Nalog kreiran! Dobrodošli u ScoutOS.",
      invalid: "Pogrešan email ili lozinka.",
    },
    dashboard: {
      title: "Kontrolna Tabla", welcome: "Dobrodošli nazad",
      subscription: "Pretplata", noSub: "Nema aktivne pretplate", active: "Aktivna",
      manage: "Upravljaj Planovima", watchlist: "Moja Lista", watchlistEmpty: "Vaša lista je prazna. Počnite pretragu igrača.",
      views: "Pregledi Profila", role: "Uloga", browse: "Pregledaj Igrače",
    },
    footer: { tagline: "Operativni Sistem za Fudbalski Skauting", product: "Proizvod", company: "Kompanija", legal: "Pravno", rights: "Sva prava zadržana." },
    payment: { processing: "Obrada plaćanja...", success: "Plaćanje uspešno! Vaša pretplata je sada aktivna.", failed: "Plaćanje neuspešno ili otkazano.", checking: "Provera statusa plaćanja...", timeout: "Provera plaćanja je istekla. Proverite kontrolnu tablu." },
    contact: {
      title: "Kontaktirajte nas", subtitle: "Pitanja, partnerstva ili podrška — rado ćemo vas saslušati.",
      name: "Puno ime", email: "Email", subject: "Naslov", message: "Poruka",
      namePh: "Petar Petrović", emailPh: "you@email.com", subjectPh: "Kako možemo pomoći?", messagePh: "Napišite svoju poruku...",
      send: "Pošalji Poruku", sending: "Slanje...",
      success: "Poruka poslata! Uskoro ćemo vam se javiti.", error: "Nešto je pošlo naopako. Pokušajte ponovo.",
      infoTitle: "Kontakt informacije", emailLabel: "Pošaljite nam email", responseTime: "Obično odgovaramo u roku od 24 sata.",
    },
    roles: { player: "Igrač / Roditelj", academy_agent: "Pro Akademija / Agent", pro_team: "Profesionalni Tim" },
    onboard: {
      title: "Dobrodošli u ScoutOS", subtitle: "Recite nam ko ste da započnete",
      playerDesc: "Napravite besplatan profil sa snimcima i statistikom. Budite otkriveni.",
      academyDesc: "Pretražujte i skautirajte verifikovane profile. 7 dana besplatno.",
      proDesc: "Kompletan skauting paket za profesionalne klubove. 7 dana besplatno.",
      continue: "Nastavi", free: "Zauvek besplatno", trial: "7 dana besplatna proba",
    },
    sub: {
      monthly: "Mesečno", annual: "Godišnje", save: "2 meseca gratis", trialBadge: "7 dana besplatno",
      startTrial: "Započni Besplatnu Probu", trialing: "Proba", active: "Aktivna", canceled: "Otkazana",
      trialEnds: "Proba ističe", renews: "Obnavlja se", perMonth: "/mes", perYear: "/god",
      needSub: "Potrebna vam je aktivna pretplata ili proba da vidite igrače.", viewPlans: "Pogledaj Planove",
      checking: "Potvrđivanje pretplate...", started: "Vaša besplatna proba je počela!",
    },
    myprofile: {
      title: "Moj Profil Igrača", subtitle: "Popunite profil i dodajte svoje najbolje snimke",
      name: "Puno ime", position: "Pozicija", city: "Grad", country: "Država", height: "Visina (cm)",
      foot: "Noga", birthYear: "Godina rođenja", club: "Klub / Tim", bio: "Biografija", openTrial: "Dostupan za probu",
      videos: "Snimci", videoTitle: "Naslov snimka", videoUrl: "Link snimka", addVideo: "Dodaj snimak", save: "Sačuvaj Profil",
      saved: "Profil sačuvan!", guide: "Vodič za Snimke", guideHint: "Ne znate kako da snimite? Pogledajte vodič",
      noVideos: "Još nema snimaka. Dodajte prvi link iznad.",
      consent: "Potvrđujem da za igrače mlađe od 18 godina imam saglasnost roditelja ili zakonskog staratelja za kreiranje i objavljivanje ovog profila.",
      consentRequired: "Saglasnost roditelja/staratelja je obavezna za registraciju maloletnika.",
    },
  },
};
